// extracted by mini-css-extract-plugin
export default {"image":"Result__image--3GwTN","content":"Result__content--31FgW"};